export type ThemeMode = 'light' | 'dark';

export interface ThemeColors {
  accent: string;
  accentHover: string;
  bg: string;
  bgCard: string;
  text: string;
  textSecondary: string;
  border: string;
  shadow: string;
  shadowHover: string;
  statusSuccess: string;
  statusInfo: string;
  statusWarning: string;
  statusError: string;
}

export const getThemeColors = (mode: ThemeMode): ThemeColors => {
  const isLight = mode === 'light';
  return {
    accent: isLight ? 'rgb(179, 160, 125)' : '#d7be96',
    accentHover: isLight ? 'rgb(159, 140, 105)' : '#c9ae82',
    bg: isLight ? '#f5f5f5' : '#1c1c1c',
    bgCard: isLight ? '#ffffff' : '#2a2a2a',
    text: isLight ? '#000000' : '#ffffff',
    textSecondary: isLight ? '#666666' : '#cacaca',
    border: isLight ? '#e0e0e0' : '#323232',
    shadow: isLight ? '0 2px 8px rgba(0,0,0,0.08)' : '0 2px 8px rgba(0,0,0,0.4)',
    shadowHover: isLight ? '0 12px 32px rgba(0,0,0,0.15)' : '0 12px 32px rgba(0,0,0,0.6)',
    statusSuccess: '#2e7d32',
    statusInfo: '#1565c0',
    statusWarning: '#e65100',
    statusError: '#c62828',
  };
};
